import {
  revenueByMarket,
  revenueGroupedByMarket,
  revenueSnapshotKeys,
  TRevenueSnapshots,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'
import { IRevenue } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getDataOrNil } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getDataOrNil'
import { getPercentDiff } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getPercentDiff'
import { getPostfixByActualsValueType } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getPostfixByActualsValueType'
import { getDataWithChangedTotal } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/revenue/helpers/getDataWithChangedTotal'
import { getRevenueItemName } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/revenue/helpers/getRevenueItemName'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { REVENUE_TYPES } from '../../../enums/REVENUE_TYPES'

import { getRevenueValueByType } from './getRevenueValueByType'

const revenueValueFields = [
  'CurrentYearRevenue',
  'PreviousYearRevenue',
  'CurrentYearQuarter1',
  'CurrentYearQuarter2',
  'CurrentYearQuarter3',
  'CurrentYearQuarter4',
  'PrevYearQuarter1',
  'PrevYearQuarter2',
  'PrevYearQuarter3',
  'PrevYearQuarter4',
  'TwoYearsAgo',
  'ThreeYearsAgo',
]

const getRevenueValueFields = (
  item: TRevenueSnapshots[keyof TRevenueSnapshots],
  revenueType: REVENUE_TYPES,
  actualValueTypes: ActualsValueTypes[]
) => {
  return actualValueTypes.reduce<Record<string, number | null>>((acc, valueType) => {
    const postfix = getPostfixByActualsValueType(valueType)

    const valueFields = revenueValueFields.reduce<Record<string, number>>((fieldAcc, field) => {
      const key = `${field}${postfix}`

      return {
        ...fieldAcc,
        [key]: getDataOrNil(
          getRevenueValueByType({
            item,
            revenueType,
            field: key as keyof typeof item,
          })
        ),
      }
    }, {})

    const currentYearRevenue = getDataOrNil(
      getRevenueValueByType({
        item,
        revenueType,
        field: `CurrentYearRevenue${postfix}` as keyof typeof item,
      })
    )

    const previousYearRevenue = getDataOrNil(
      getRevenueValueByType({
        item,
        revenueType,
        field: `PreviousYearRevenue${postfix}` as keyof typeof item,
      })
    )

    return {
      ...acc,
      ...valueFields,
      [`YoY${postfix}`]: getPercentDiff(currentYearRevenue, previousYearRevenue),
    }
  }, {})
}

export const formRevenueDataFromFinancialData = (
  initialData: TRevenueSnapshots,
  revenueType: REVENUE_TYPES = REVENUE_TYPES.SellThru,
  markets?: string[],
  actualValueTypes: ActualsValueTypes[] = []
) => {
  const data = revenueSnapshotKeys
    .filter((key) => {
      if (!revenueByMarket.includes(key)) {
        return true
      }

      if (markets && markets.length > 0) {
        return markets.some((market) => revenueGroupedByMarket[market]?.includes(key))
      }

      return true
    })
    .map(
      (key) =>
        ({
          Name: getRevenueItemName(key),
          Key: key,
          ...getRevenueValueFields(initialData[key], revenueType, actualValueTypes),
        }) as IRevenue
    )
  return getDataWithChangedTotal(data, actualValueTypes)
}
